import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import appStore from '@/store/modules/appStore';
import userStore from '@/store/modules/userStore';
import noticeStore from '@/store/modules/noticeStore';
import buyerStore from '@/store/modules/buyerStore';
import contactStore from '@/store/modules/contactStore';
import addressStore from '@/store/modules/addressStore';
import cashStore from '@/store/modules/cashStore';
import bmStore from "@/store/modules/bmStore";
import reportStore from "@/store/modules/reportStore";
import searchStore from "@/store/modules/searchStore";
import commonStore from "@/store/modules/commonStore";
import faqStore from "@/store/modules/faqStore";
import uiStore from "@/store/modules/uiStore";
import sessionStore from "@/store/modules/sessionStore";

export default createStore({
  modules: {
    appStore,
    userStore,
    noticeStore,
    buyerStore,
    contactStore,
    addressStore,
    cashStore,
    bmStore,
    reportStore,
    searchStore,
    commonStore,
    faqStore,
    uiStore,
    sessionStore,
  },
  plugins: [
    createPersistedState({
      paths: [
        "bmStore.xExvtNo",
        "bmStore.xBuyers",
        "bmStore.xSubject",
        "bmStore.xContent",
        "bmStore.xIsReply",
        "bmStore.xMktSndNo",
        "bmStore.xForwardFiles",
      ],
    }),
    createPersistedState({
      key: "session",
      storage: window.sessionStorage,
      paths: ["sessionStore.requestNo"],
    }),
  ],
});
